import {Possessed} from "../Possessed";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {PossessedStatics} from '../config/PossessedStatics';
import {gsap} from "gsap"
import {ExorcismMysteryReel} from '../reels/PossessedMysteryReel';
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {SimpleReelModelState} from "../../core/reel/simplereel/SimpleReelModel";
import {PossessedGameMode} from "../server/PossessedGameMode";

interface HotZone {
    active:boolean;
    reelID:number;
    reelPosition:number;
    fireAnimtion:PIXI.spine.Spine;
    revealAnimation:PIXI.spine.Spine;
    reel:ExorcismMysteryReel;
}

export class PossessedReelCrossView extends PIXI.Container {

    private cross:PIXI.spine.Spine;
    private crossLight:PIXI.spine.Spine;
    private hotZones:HotZone[] = [];
    private hotZoneSpinBackground:PIXI.Sprite;

    private fullCrossFireAnimation:PIXI.spine.Spine;

    public wildReelAnticipation:PIXI.spine.Spine;

    public wildSymbolsContainer:PIXI.Container = new PIXI.Container();

    private wildGirlAnimation:PIXI.spine.Spine;
    private wildGirlMultiplierAnim:PIXI.spine.Spine;
    private wildExpandAnticipation:PIXI.spine.Spine;

    private batsTimeline:gsap.core.Timeline = gsap.timeline();
    private wildGirlBatAnimation:PIXI.spine.Spine;

    public get activeHotzoneCount():number {
        return this.hotZones.filter(hz => hz.active).length;
    }

    constructor() {
        super();
        this.name = "ReelCross";

        this.hotZoneSpinBackground = new PIXI.Sprite(Possessed.assetLoader.getTextures("Cross_bg_NORMAL/Cross_3")[0])
        this.hotZoneSpinBackground.position.set(360, 395);
        this.hotZoneSpinBackground.anchor.x = 0.5;
        this.hotZoneSpinBackground.visible = false;
        this.addChild(this.hotZoneSpinBackground);

        const hotZonePositions:{reelID:number, reelPosition:number}[] = [
            {reelID: 1, reelPosition: 3}, 
            {reelID: 2, reelPosition: 4},
            {reelID: 3, reelPosition: 3},
            {reelID: 2, reelPosition: 3},
            {reelID: 2, reelPosition: 2},
            {reelID: 2, reelPosition: 1},
        ];
        hotZonePositions.forEach(pos => {
            const hz:HotZone = {
                active : false,
                reelID : pos.reelID,
                reelPosition : pos.reelPosition,
                fireAnimtion : new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.HOTZONE_ANIMATION)),
                revealAnimation: new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.SYMBOL_REVEAL_ANIMATION)),
                reel : new ExorcismMysteryReel(pos.reelID, pos.reelPosition)
            };
            hz.revealAnimation.visible = false;
            hz.fireAnimtion.visible = false;
            hz.fireAnimtion.position.set(
                PossessedStatics.SYMBOL_WIDTH/2 + pos.reelID * PossessedStatics.SYMBOL_WIDTH,
                152 + pos.reelPosition * PossessedStatics.SYMBOL_HEIGHT
            );
            hz.revealAnimation.position.copyFrom(hz.fireAnimtion.position);
            hz.reel.stepDuration = 0.05;
            hz.reel.init();
            hz.reel.position.set(0, 152 + (pos.reelPosition * PossessedStatics.SYMBOL_HEIGHT));
            this.hotZones.push(hz);
        })

        this.addChild(...this.getAllMysteryReels());

        this.cross = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.REEL_CROSS_ANIMATION));
        this.cross.name = "ReelCross";
        //(<PIXI.Point>this.cross.anchor).set(0.5, 0.5);
        this.cross.position.set(360, 447);
        this.cross.state.setAnimation(0, "crossFrame", true);

        this.crossLight = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset("spine/crossLight.json"));
        this.crossLight.position.copyFrom(this.cross.position);
        this.crossLight.state.setAnimation(0, "crossLight", true);

        this.addChild(this.cross, this.crossLight);

        //this.addChild(this.wildSymbolsContainer);

        this.fullCrossFireAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.HOTZONE_ANIMATION));
        this.fullCrossFireAnimation.visible = false;
        this.fullCrossFireAnimation.position.copyFrom(this.cross.position);
        this.addChild(this.fullCrossFireAnimation);

        this.addChild(...this.hotZones.map(hz => hz.fireAnimtion));
        this.addChild(...this.hotZones.map(hz => hz.revealAnimation));

        this.wildGirlAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.WILD_EXPANDED_ANIMATION));
        this.wildGirlAnimation.name = "WildGirlAnimation";
        //this.wildGirlAnimation.position.set(360, 360 + PossessedStatics.SYMBOL_HEIGHT);
        this.wildGirlAnimation.position.copyFrom(this.cross.position);
        this.wildGirlAnimation.visible = false;

        this.wildGirlMultiplierAnim  = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.MULTIPLIER_NUMBER_ANIMATION));
        this.wildGirlMultiplierAnim.name = "WildGirlMultiplier";
        this.wildGirlMultiplierAnim.position.copyFrom(this.wildGirlAnimation.position);
        this.wildGirlMultiplierAnim.position.y += PossessedStatics.SYMBOL_HEIGHT;
        this.wildGirlMultiplierAnim.visible = false;

        this.wildExpandAnticipation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.WILD_EXPAND_REEL_ANTICIPATION));
        this.wildExpandAnticipation.position.set(360, 360);
        this.wildExpandAnticipation.position.y += PossessedStatics.SYMBOL_HEIGHT/2;
        this.wildExpandAnticipation.visible = false;

        this.wildReelAnticipation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset("spine/greenAnticipation.json"));
        this.wildReelAnticipation.position.set(360, 360);
        this.wildReelAnticipation.visible = false;

        this.wildGirlBatAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.WILD_EXPAND_BLACK_PARTICLE));
        this.wildGirlBatAnimation.position.set(360, 360);
        this.wildGirlBatAnimation.visible = false;

        this.addChild(this.wildExpandAnticipation);
        this.addChild(this.wildReelAnticipation);
        this.addChild(this.wildSymbolsContainer);
        this.addChild(this.wildGirlAnimation);
        this.addChild(this.wildGirlMultiplierAnim);
        this.addChild(this.wildGirlBatAnimation);

        this.updateCross(Possessed.model.data.mode);
    }

    public updateCross(mode:string) {
        switch(mode) {
            case "XBET":
                this.cross.skeleton.setSkinByName("xbet");
                break;
            case PossessedGameMode.NORMAL:
                this.cross.skeleton.setSkinByName("main");
                break;
            case PossessedGameMode.FREESPIN:
                this.cross.skeleton.setSkinByName("fs");
                break;
            case PossessedGameMode.FREESPIN_SUPER:
                this.cross.skeleton.setSkinByName("sfs");
                break;
        }
        SpineGSAPWrapper.resetSpineState(this.cross);
        this.cross.state.setAnimation(0, "crossFrame", true);
    }

    public updateHotZones(hotZones:number):gsap.core.Timeline {
        const tl = gsap.timeline();

        const currentHotZones = this.activeHotzoneCount;

        let playedFireTriggeredSound = false;

        if(hotZones != 6) {
            tl.add(()=> {this.fullCrossFireAnimation.visible = false;})
            this.hotZones.forEach((zone, index) => {
                if(!zone.active && index+1 <= hotZones) {
                    tl.add(() => {
                        SpineGSAPWrapper.resetSpineState(zone.fireAnimtion);
                        zone.fireAnimtion.alpha = 0;
                    }, 0)
                    tl.add(gsap.to(zone.fireAnimtion, {alpha: 1, duration: 0.3}), 0)
                    tl.add(SpineGSAPWrapper.createTimeline(zone.fireAnimtion, 0, "triggered"), "<");
                    tl.add(() => {
                        if(currentHotZones == 0 && index == 0) {
                            Possessed.soundPlayer.playSound("xactCrossStart");
                            Possessed.soundPlayer.playLoopingSound("xactCrossLoop");
                        } else if(currentHotZones != 0 && !playedFireTriggeredSound){
                            Possessed.soundPlayer.playSound("xactCrossAdd");
                            playedFireTriggeredSound = true;
                        }
                    }, "<")
                    tl.add(() => {
                        zone.fireAnimtion.state.setAnimation(0, "static", true)
                        zone.active = true;
                    }, ">")
                }
                else if(zone.active && index+1 > hotZones) {
                    tl.add(() => {
                        zone.fireAnimtion.visible = false
                        zone.active = false;
                    });
                }
            });
        } else {
            if(this.fullCrossFireAnimation.visible == false) {
                this.hotZones.forEach(zone => {
                    tl.add(()=> {zone.fireAnimtion.visible = false})
                });
                tl.add(()=>{
                    SpineGSAPWrapper.resetSpineState(this.fullCrossFireAnimation);
                })
                tl.add(SpineGSAPWrapper.createTimeline(this.fullCrossFireAnimation, 0, "hotTrigger"))
                tl.add(() => {
                    if(currentHotZones == 0) {
                        Possessed.soundPlayer.playSound("xactCrossStart");
                        Possessed.soundPlayer.playLoopingSound("xactCrossLoop");
                    } else if(currentHotZones != 0 && !playedFireTriggeredSound){
                        Possessed.soundPlayer.playSound("xactCrossAdd");
                    }
                }, "<")
                tl.add(()=>{this.fullCrossFireAnimation.state.setAnimation(0, "hotLoop", true)});
            }
        }

        if(hotZones == 0) {
            tl.add(() => {
                Possessed.soundPlayer.stopSound("xactCrossLoop", 300);
            })
        }

        return tl;
    }

    public getActiveHotZonesAtReel(reelID:number):HotZone[] {
        return this.hotZones.filter(hz => hz.active && hz.reelID == reelID);
    }

    public setFireSpinAnimationAtReel(reelID:number, reverse:boolean) {
        const fullCrossAnim = reverse ? "hotSpinningR" : "hotSpinning";
        this.fullCrossFireAnimation.state.setAnimation(0, fullCrossAnim, true);
        this.getActiveHotZonesAtReel(reelID).forEach(zone => zone.fireAnimtion.state.setAnimation(0, "spinning", true));
    }
    public setFireStaticAnimationAtReel(reelID:number) {
        this.fullCrossFireAnimation.state.setAnimation(0, "hotLoop", true);
        this.getActiveHotZonesAtReel(reelID).forEach(zone => zone.fireAnimtion.state.setAnimation(0, "static", true))
    }

    public dimActiveHotZones():gsap.core.Timeline {
        const tl = gsap.timeline();
        this.hotZones.filter(hz => hz.active).forEach(hotzone => {
            tl.add(gsap.to(hotzone.fireAnimtion, {alpha: 0.4, duration: 0.1}), "<")
        });
        return tl;
    }
    public removeHotzoneDim():gsap.core.Timeline {
        const tl = gsap.timeline();
        this.hotZones.filter(hz => hz.active).forEach(hotzone => {
            tl.add(gsap.to(hotzone.fireAnimtion, {alpha: 1, duration: 0.1}), "<")
        });
        return tl;
    }

    public getMysteryReel(reelID:number, reelPosition:number):ExorcismMysteryReel|undefined {
         return this.hotZones.find(reel => reel.reelPosition == reelPosition && reel.reelID == reelID)?.reel;
    }
    public getAllMysteryReels():ExorcismMysteryReel[] {
        return this.hotZones.map(hz => hz.reel);
    }

    public getActiveMysteryReels():ExorcismMysteryReel[] {
        return this.hotZones.slice(0, Possessed.model.gameData.nextHotZoneSize).map(hz => hz.reel);
    }

    public spinMysteryReels(hotZones:number, reelSet:string[], reverse:boolean) : gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(()=> {
            let crossBgTexture = "Cross_bg_";
            crossBgTexture +=  Possessed.model.isFreespins() || Possessed.model.triggeredFreespins() ? "FREESPIN" :
                Possessed.xbetEnabled ? "XBET" : "NORMAL";
            crossBgTexture += "/Cross_";

            let crossTextureIndex = 1;
            this.hotZoneSpinBackground.anchor.y = 0;
            if(hotZones > 3) {
                crossTextureIndex = 2;
            } if(hotZones > 4) {
                crossTextureIndex = 3;
                this.hotZoneSpinBackground.anchor.y = 0.33;
            } if(hotZones > 5) {
                crossTextureIndex = 4;
                this.hotZoneSpinBackground.anchor.y = 0.5;
            }
            crossBgTexture += crossTextureIndex;

            this.hotZoneSpinBackground.texture = Possessed.assetLoader.getTextures(crossBgTexture)[0];
            this.hotZoneSpinBackground.visible = true;
        })
        const isFullCross = Possessed.model.hasFullCrossSymbol() && Possessed.model.getFullCrossSymbolName() != "W";
        // Fire spin animation
        if(hotZones == 6) {
            const fireAnim = reverse ? "hotSpinningR" : "hotSpinning";
            this.fullCrossFireAnimation.state.setAnimation(0, fireAnim, true);
        }
        this.hotZones.slice(0, hotZones).forEach(hz => {
            tl.add(() => {
                if(hotZones != 6) {
                    hz.fireAnimtion.state.setAnimation(0, "spinning", true);
                }
                hz.reel.updateReelSet(reelSet);
                hz.reel.isFullCross = isFullCross;
                hz.reel.start(reverse);
                }, "<");
        });
        return tl;
    }

    public stopMysteryReels(reverse:boolean, stopSymbol:string) : gsap.core.Timeline {
        const tl = gsap.timeline();

        const spinningHotZones = this.hotZones.filter(hz => hz.reel.getState() == SimpleReelModelState.SPIN);

        if(spinningHotZones.length == 6) {
            tl.add(() => {
                this.fullCrossFireAnimation.state.setAnimation(0, "hotLoop", true);
            });
        }

        const isFullCrossSymbol = Possessed.model.hasFullCrossSymbol() && Possessed.model.getFullCrossSymbolName() != "W";
        tl.add(()=> {
            spinningHotZones.forEach(hz => {
                SpineGSAPWrapper.resetSpineState(hz.revealAnimation)
                // In case of wild expand hiding mystery reel we also hide the reveal animation since we have nothing to reveal
                if(!hz.reel.visible) {
                    hz.revealAnimation.visible = false;
                }
            });

        })

        tl.add(spinningHotZones.map(hz => SpineGSAPWrapper.createTimeline(hz.revealAnimation, 0, "reveal", 0)));
        tl.add(() => {
            Possessed.soundPlayer.playSound("xactCrossReveal");
        }, "<")
        spinningHotZones.forEach(((hz, index) => {
            tl.add(()=> {
                hz.reel.isFullCross = isFullCrossSymbol;
                if(spinningHotZones.length != 6) {
                    hz.fireAnimtion.state.setAnimation(0, "static", true);
                }
                hz.reel.stop(stopSymbol, 0.3, reverse);
            }, index == 0 ? "<0.47" : "<");
        }));

        tl.add(() => {
            this.hotZoneSpinBackground.visible = false;
        }, ">0.3")

        tl.add(()=> {
            spinningHotZones.forEach(hz => hz.revealAnimation.visible = false);
        })

        return tl;
    }

    public onRestore() {
        if(Possessed.model.data.nextHotZoneSize == 6) {
            this.fullCrossFireAnimation.visible = true;
            this.fullCrossFireAnimation.state.setAnimation(0, "hotLoop", true);
            this.hotZones.forEach(hz => hz.active = true);
        } else {
            for(let i:number=0;i < Possessed.model.data.nextHotZoneSize; i++) {
                this.hotZones[i].fireAnimtion.visible = true;
                this.hotZones[i].fireAnimtion.state.setAnimation(0, "static", true);
                this.hotZones[i].active = true;
            }
        }
    }

    public playWildExpandAnticipation():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                SpineGSAPWrapper.resetSpineState(this.wildExpandAnticipation);
                this.wildExpandAnticipation.state.setAnimation(0, "loop", true);
            })
    }
    public fadeOutWildExpandAnticipation(fadeOutDur:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.wildExpandAnticipation, {alpha: 0, duration: fadeOutDur}))
            .add(() => {
                this.wildExpandAnticipation.visible = false;
                this.wildExpandAnticipation.alpha = 1;
            })
    }

    private playBatsAnimation() {
        this.batsTimeline.kill();
        this.batsTimeline = gsap.timeline()
            .add(() => {
                SpineGSAPWrapper.resetSpineState(this.wildGirlBatAnimation);
            })
            .add(SpineGSAPWrapper.createTimeline(this.wildGirlBatAnimation, 0, "batB"))
    }

    public triggerWildGirl(multiplier:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(()=> {
            SpineGSAPWrapper.resetSpineState(this.wildGirlAnimation);
            SpineGSAPWrapper.resetSpineState(this.wildGirlMultiplierAnim);
        });
        tl.add(SpineGSAPWrapper.createTimeline(this.wildGirlAnimation, 0, "trigger"), "<");
        if(multiplier >= 2) {
            tl.add(SpineGSAPWrapper.createTimeline(this.wildGirlMultiplierAnim, 0, `X${multiplier}`, 0), "<");
        }
        tl.add(()=> {
            this.wildGirlAnimation.state.setAnimation(0, "idle", true)
        });
        tl.add(() => {
            this.playBatsAnimation();
        }, 0);
        return tl;
    }

    public fadeOutWildGirl(fadeDuration:number) {
        return gsap.timeline()
            .add(gsap.to(this.wildGirlAnimation, {alpha: 0, duration: fadeDuration}))
            .add(gsap.to(this.wildGirlMultiplierAnim, {alpha: 0, duration: fadeDuration}), "<")
            .add(() => {
                this.wildGirlAnimation.visible = false;
                this.wildGirlAnimation.alpha = 1;

                this.wildGirlMultiplierAnim.visible = false;
                this.wildGirlMultiplierAnim.alpha = 1;
            })
    }
}